import Login from "../views/auth/Login.vue";
import Oauth from "../views/auth/Oauth.vue";
import Dashboard from "../views/app/Dashboard.vue";
import NotFound from "../views/app/NotFound.vue";
import SquadManagement from "../views/squad-management/SquadManagement.vue";
import UnderConstruction from "../views/app/UnderConstruction.vue";
import Verify from "../views/verify/Verify.vue";
import PendingRole from "../views/app/PendingRole.vue";
import TeamList from "../views/team-lists/TeamList.vue";
import TeamMatches from "../views/team-lists/TeamMatches.vue";
import Matches from "../views/matches/Matches.vue";
import RefereeAppointment from "../views/referee/refereeAppointment.vue";
import MatchDetail from "../views/matches/MatchDetail.vue";
import CompetitionCases from "../views/competition-cases/CompetitionCases.vue";
import CompetitionCaseAdd from "../views/competition-cases/CompetitionCaseAdd.vue";
import CompetitionCaseDetail from "../views/competition-cases/CompetitionCaseDetail.vue";
import TrainingLists from "../views/training-participant/TrainingLists.vue";
import TrainingDetail from "../views/training-participant/TrainingDetail.vue";
import MyMembers from "../views/my-members/MyMembers.vue";
import MyMemberDetails from "../views/my-members/MyMemberDetails.vue";
import InjuryCases from "../views/Injury-cases/InjuryCases.vue";
import InjuryCaseSteps from "../views/Injury-cases/InjuryCaseSteps.vue";
import hiaForm from "../views/Injury-cases/hiaForm.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    meta: {
      displayName: null,
      layout: "login",
    },
    component: Login,
  },
  {
    path: "/oauth",
    name: "oauth",
    meta: {
      displayName: "Login",
      layout: "login",
    },
    component: Oauth,
  },
  {
    path: "*",
    name: "404",
    meta: {
      displayName: "Page Not Found",
      layout: "login",
    },
    component: NotFound,
  },
  {
    path: "/",
    name: "dashboard",
    meta: {
      displayName: "Dashboard",
      layout: "app",
      requiresAuth: true,
    },
    component: Dashboard,
  },
  {
    path: "/under-construction",
    name: "under-construction",
    meta: {
      displayName: "Under Construction",
      layout: "app",
      requiresAuth: true,
    },
    component: UnderConstruction,
  },
  {
    path: "/maintenance",
    name: "maintenance",
    meta: {
      displayName: "Maintenance access",
      layout: "app",
      requiresAuth: true,
    },
    component: () => import("@/views/app/Maintenance.vue"),
  },
  {
    path: "/matches",
    name: "matches",
    meta: {
      displayName: "Matches",
      layout: "app",
      requiresAuth: true,
    },
    component: Matches,
  },
  {
    path: "/refereeappointments",
    name: "referee Appointments",
    meta: {
      displayName: "Matches with Referee Appointments",
      layout: "app",
      requiresAuth: true,
    },
    component: RefereeAppointment,
  },
  {
    path: "/teams/:teamId/matches/:matchId",
    name: "match.detail",
    meta: {
      displayName: "Match Detail",
      layout: "app",
      requiresAuth: true,
      headerMenu: [
        { type: "go-team-list", name: "Go to teamlist" },
        { type: "dispute-match", name: "Dispute match" },
      ],
    },
    component: MatchDetail,
  },
  {
    path: "/squad-management",
    name: "squadManagement",
    meta: {
      displayName: "Squads",
      layout: "app",
      requiresAuth: true,
    },
    component: SquadManagement,
  },
  // {
  //   path: "/hiaForm",
  //   name: "hiaForm",
  //   meta: {
  //     displayName: "hiaForm",
  //     layout: "app",
  //     requiresAuth: true,
  //   },
  //   component: hiaForm,
  // },
  {
    path: "/hia-form/:id",
    name: "hiaForm",
    meta: {
      displayName: "hiaForm",
      layout: "app",
      requiresAuth: true,
    },
    component: hiaForm,
  },
  {
    path: "/team-lists",
    name: "teamLists.matches",
    meta: {
      displayName: "Team List",
      layout: "app",
      requiresAuth: true,
    },
    component: TeamMatches,
  },
  {
    path: "/team-lists/teams/:teamId/matches/:matchId",
    name: "teamLists.management",
    meta: {
      displayName: "Team List",
      layout: "app",
      requiresAuth: true,
    },
    component: TeamList,
  },
  // --------- Training Attendance ---------
  {
    path: "/training-participants",
    name: "training-participants.list",
    meta: {
      displayName: "Training Attendances",
      layout: "app",
      requiresAuth: true,
    },
    component: TrainingLists,
  },
  {
    path: "/training-participants/:id",
    name: "training-participants.edit",
    meta: {
      displayName: "Training Attendances",
      layout: "app",
      requiresAuth: true,
    },
    component: TrainingDetail,
  },
  {
    path: "/training-participants/add",
    name: "training-participants.add",
    meta: {
      displayName: "Training Attendances",
      layout: "app",
      requiresAuth: true,
    },
    component: TrainingDetail,
  },
  // --------- Competition Cases ---------
  {
    path: "/competition-cases",
    name: "competition-cases",
    meta: {
      displayName: "Cases",
      layout: "app",
      requiresAuth: true,
    },
    component: CompetitionCases,
  },
  {
    path: "/competition-cases/add",
    name: "competition-cases.add",
    meta: {
      displayName: "Cases",
      layout: "app",
      requiresAuth: true,
    },
    component: CompetitionCaseAdd,
  },
  {
    path: "/competition-cases/:id/view",
    name: "competition-cases.view",
    meta: {
      displayName: "Cases",
      layout: "app",
      requiresAuth: true,
    },
    component: CompetitionCaseDetail,
  },
  {
    path: "/my-members",
    name: "my-members.list",
    meta: {
      displayName: "My Members",
      layout: "app",
      requiresAuth: true,
    },
    component: MyMembers,
  },
  {
    path: "/my-members/:id",
    name: "my-members.details",
    meta: {
      displayName: "Member Details",
      layout: "app",
      requiresAuth: true,
    },
    component: MyMemberDetails,
  },
  // --------- End Competition Cases ---------
  {
    path: "/verify/",
    name: "verify",
    meta: {
      displayName: "Verification",
      layout: "login",
      requiresAuth: false,
    },
    component: Verify,
  },
  {
    path: "/pending/",
    name: "pending",
    meta: {
      displayName: "Pending",
      layout: "login",
      requiresAuth: false,
    },
    component: PendingRole,
  },
  // --------- Injury Cases ---------
  {
    path: "/injury-cases",
    name: "injury-cases",
    meta: {
      displayName: "Injury Cases",
      layout: "app",
      requiresAuth: true,
    },
    component: InjuryCases,
  },
  {
    path: "/injury-cases-add",
    name: "injury-cases-add",
    meta: {
      displayName: "Injury Report",
      layout: "app",
      requiresAuth: true,
    },
    component: InjuryCaseSteps,
  },
  {
    path: "/injury-cases/:id",
    name: "injury-cases.update",
    meta: {
      displayName: "Injury Report",
      layout: "app",
      requiresAuth: true,
    },
    component: InjuryCaseSteps,
  },
];

export default routes;
